import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertService } from '../../../core/alerts/alert.service';

@Component({
    selector: 'app-statistik-netomsla-options',
    templateUrl: './statistik-netomsla-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikNetomslaOptionsComponent {
    @Input() periode: {fra: string, til: string};
    @Output() periodeChange = new EventEmitter<{fra: string, til: string}>();
    @Output() selectYear = new EventEmitter<number>();
    @Output() exportExcel = new EventEmitter();

    selectedYear = 1;

    constructor(
        private alert: AlertService,
    ) { }

    onFraChange(fra: string, isValidDate: boolean) {
        if (!isValidDate || !fra) { return; }
        if (!this.isValidPeriode(fra, this.periode.til)) { return; }
        this.periode.fra = fra;
        this.onPeriodeChange();
    }

    onTilChange(til: string, isValidDate: boolean) {
        if (!isValidDate || !til) { return; }
        if (!this.isValidPeriode(this.periode.fra, til)) { return; }
        this.periode.til = til;
        this.onPeriodeChange();
    }

    onSelectYear(year: number) {
        this.selectedYear = year;
        this.selectYear.emit(year);
    }

    private isValidPeriode(fra: string, til: string) {
        if (new Date(fra) > new Date(til)) {
            this.alert.createAlert(
                'Til dato skal være større end fra dato!',
                'danger'
            );
            return false;
        }
        return true;
    }

    private onPeriodeChange() {
        if (!this.periode.fra || !this.periode.til) { return; }
        this.periodeChange.emit({fra: this.periode.fra, til: this.periode.til});
    }

    onExportExcel() {
        this.exportExcel.emit();
    }
}
